import { render, staticRenderFns } from "./we-circular-view.vue?vue&type=template&id=2efce7bc&"
import script from "./we-circular-view.vue?vue&type=script&lang=js&"
export * from "./we-circular-view.vue?vue&type=script&lang=js&"
import style0 from "./we-circular-view.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports